import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getCurrentMarketplace, getMarketplaceLanguage,
  getMarketplaceSelectedPlacement,
} from 'src/store/marketplace/selectors';
import { useStyles as useCardStyles } from 'src/components/Marketplace/pages/UnitsList/FilterPlacementCard/styles';
import { isObject } from 'lodash';
import { getValueByPlacementSystemName } from 'src/helpers/placementSystemName';
import { useStyles as useBookNowAsideStyles } from './styles';

export const BookNowAside: React.FC = () => {
  const classes = useBookNowAsideStyles();
  const cardStyles = useCardStyles();
  const marketplace = useSelector(getCurrentMarketplace);
  const placement = useSelector(getMarketplaceSelectedPlacement);
  const lang = useSelector(getMarketplaceLanguage);

  const config = useMemo(() => marketplace?.frontConfiguration?.module?.placementTile, [marketplace]);

  return (
    <>
      { marketplace && lang && (
        <div className={classes.container}>
          <div className={classes.galleryWrapper}>
            {placement?.urls?.gallery?.[0] && (
            <img src={placement?.urls?.gallery?.[0]} alt="gallery" className={cardStyles.planImage} />
            )}
          </div>
          <div className={cardStyles.title}>
            {config?.card.secondHeader.isActive
          && config?.card.secondHeader.elements.map((el) => {
            // @ts-ignore
            const value = isObject(placement[el.property.systemName]) ? placement[el.property.systemName][lang] : placement[el.property.systemName];
            return (
              <React.Fragment key={el['@id']}>
                <span>
                  { el.prefix?.[lang] }
                  {' '}
                  { value }
                  {' '}
                  { el.suffix?.[lang] }
                </span>
                {el.iconFileUri?.fileUrl && (
                  <img width="5px" src={el.iconFileUri?.fileUrl} alt="divider" />
                )}
              </React.Fragment>
            );
          })}
          </div>
          <div className={cardStyles.features}>
            { config?.card.cardIcons.firstBlock.isActive
              && config?.card.cardIcons.firstBlock.elements.map((el) => {
                const value = getValueByPlacementSystemName(placement, el.property.systemName, { lang });
                return (
                  <React.Fragment key={el['@id']}>
                    { value ? (
                      <div className={cardStyles.featuresItem}>
                        { el.iconFileUri?.fileUrl && (
                          <img
                            src={el.iconFileUri?.fileUrl}
                            alt="first block element"
                            className={cardStyles.featureIcon}
                          />
                        ) }
                        { el.prefix?.[lang] }
                        { ' ' }
                        { value }
                        { ' ' }
                        { el.suffix?.[lang] }
                      </div>
                    ) : null }
                  </React.Fragment>
                );
              }) }
          </div>
        </div>
      )}
    </>
  );
};
